<div echarts (chartInit)="onChartInit($event)" [options]="options"></div>